import React from 'react'
import styled from 'styled-components'
import { LabelStyle, SmallStyle } from 'components/styled/typography/styles'
import { Box } from 'components/styled/containers/box'
import {
  StyledTextInput,
  StyledTextInputProps,
} from 'components/form-components/styled-text-input/index'
import FormErrors from 'components/form-components/form-errors'
import { Flex } from 'components/styled/containers/flex'
import { Small } from 'components/styled/typography'

export interface FieldProps extends StyledTextInputProps {
  title: string
  subtitle?: string
  action?: React.ReactNode
  isRequired?: boolean
}

export const StyledField = styled.div`
  margin-bottom: ${({ theme }) => theme.space.s20};
`

export const FieldLabel = styled.span`
  ${LabelStyle};
  margin-bottom: ${({ theme }) => theme.space.s20};
  color: ${({ theme }) => theme.color.grey90};
`

export const FieldSubLabel = styled.span`
  ${SmallStyle};
  font-style: italic;
  margin-left: ${({ theme }) => theme.space.s4};
  margin-bottom: ${({ theme }) => theme.space.s8};
`

export const LabelledInput: React.FC<FieldProps> = ({
  title,
  subtitle,
  action,
  isRequired = false,
  model,
  ...props
}) => {
  return (
    <div>
      <Box mb="s8">
        <FieldLabel>{`${title} ${isRequired ? '*' : ''}`}</FieldLabel>
        {subtitle && <FieldSubLabel>{subtitle}</FieldSubLabel>}
        {action && (
          <Small mt="s8" mb="s4">
            {action}
          </Small>
        )}
      </Box>
      <StyledTextInput {...props} model={model} />
      <FormErrors model={model} />
    </div>
  )
}
